<template>
  <div>
    <mdb-btn @click="$emit('finished')" icon="arrow-left">Back to Console</mdb-btn>
    <mdb-btn @click="listEvents" icon="recycle">Refresh</mdb-btn>

    <mdb-card v-if="events">
      <mdb-card-header class="secondary-color-dark text-white">
        <h5>Events</h5>
      </mdb-card-header>
      <mdb-card-body>
        <mdb-tbl striped responsive>
          <mdb-tbl-head>
            <tr class="secondary-color text-white">
              <th>Rule</th>
              <th>State</th>
              <th>Schedule</th>
              <th>Targets</th>
            </tr>
          </mdb-tbl-head>
          <mdb-tbl-body>
            <tr v-for="(event,i) in events" :key="i">
              <td>
                <h5>{{event.rule.name}}</h5>
                <div class="text-info">{{event.rule.description}}</div>
                <div class="text-info small">{{event.rule.arn}}</div>
              </td>
              <td>
                <div :class="event.rule.state == 'ENABLED' ? 'text-success' : 'text-danger'">{{event.rule.state}}</div>
                <mdb-btn @click="toggleState(event.rule)" size="sm"
                  :color="event.rule.state == 'ENABLED' ? 'danger' : 'success'"
                > {{event.rule.state == 'ENABLED' ? 'Disable' : 'Enable'}}  </mdb-btn>
              </td>
              <td>
                {{event.rule.scheduleExpression}}
              </td>
              <td>
                <div v-for="(target,i) in event.targets" :key="i">
                  {{ formatTargetArn(target.arn)}}<br/>
                  {{target.input}}
                </div>
              </td>
            </tr>
          </mdb-tbl-body>
        </mdb-tbl>
      </mdb-card-body>

    </mdb-card>

  </div>

</template>
<script>
import api from '../../services/groupsPlaceApi.js'
import {
  mdbBtn,
  mdbCard,
  mdbCardBody,
  mdbCardFooter,
  mdbCardHeader,
  mdbContainer,
  mdbInput,
  mdbTbl,
  mdbTblBody,
  mdbTblHead
} from 'mdbvue';

export default {
  name: "admin-aws-lbtargets",
  display: "Targets",
  order: 1,
  components: {
    mdbContainer,
    mdbInput,
    mdbBtn,
    mdbCard,
    mdbCardHeader,
    mdbCardBody,
    mdbCardFooter,
    mdbTbl,
    mdbTblBody,
    mdbTblHead
  },
  computed: {
    userDetails: function () {
      return this.$store.state.userDetails
    }
  },
  mounted() {
    this.listEvents()
  },
  data() {
    return {
      events: null
    }
  },
  methods: {
    formatTargetArn(t) {
      if (!t) return "???"
      let parts = t.split(":")
      return parts[parts.length-1]
    },
    listEvents() {
      this.$store.dispatch("setExecuting", true)
      api.get("/aws/events/").then(
        (details) => {
          this.events = details.data
        },
        (error) => {
          this.$notify.error({message: error.response.data})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    toggleState(r) {
      this.$store.dispatch("setExecuting", true)
      api.post("/aws/toggleRuleState/", r).then(
        (details) => {
          r.state = details.data.newState
        },
        (error) => {
          this.$notify.error({message: error.response.data})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    }
  }

}
;
</script>
